import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="bg-ice-light text-navy" data-id="element-45" data-mp="1ntzxx8rhxr1b">
      <div className="mx-auto max-w-xl px-3 py-5 sm:px-5" data-id="element-46" data-mp="2bkcfzcggh45m">
        <h2 id="faq" className="text-center font-display text-[1.5rem] font-extrabold leading-none tracking-tight sm:text-4xl" data-id="element-47" data-mp="2bkvt8fv5v4db">
          Preguntas frecuentes
        </h2>

        <div className="mt-3 space-y-1.5" data-id="element-48" data-mp="21uaosbst35mh">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className={`rounded-xl border-2 bg-white transition-colors duration-150 ease-out ${isOpen ? 'border-brand' : 'border-navy/15'}`} data-id="element-49" data-mp="2ujhubuqogvh8" data-mpi={i}>
                <h3 data-id="element-50" data-mp="1vqarsakur6yu">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-2.5 rounded-xl px-3 py-2 text-left" data-id="element-51" data-mp="1vnoju9u1upg3">
                    <span className="font-sub text-sm font-semibold leading-snug" data-id="element-52" data-mp="2fcpd2a7ylld9">
                      {faq.q}
                    </span>
                    <ChevronDownIcon size={16} className={`flex-shrink-0 text-cta transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-53" data-mp="2agrtlv1efyw9" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-54" data-mp="p1ccx47esowf">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: EASE
              }} className="overflow-hidden" data-id="element-55" data-mp="p3p2o3jes3k1">
                      <p className="px-3 pb-2 text-sm leading-snug text-slate-600" data-id="element-56" data-mp="3318spyfximna">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}